import senai from "./assets/image.png";
import logoAdepe from "./assets/logo-adepe.png";
import Typography from "../Typography";
import logoGovPe from "./assets/logo-gov-pe.png";
import logoSdec from "./assets/logo-sdec.png";

export function Footer() {
  return (
    <div className="fixed w-full top-auto bg-white h-[9vh] bottom-0 my-1 gap-10 px-4 flex">
      <div>
        <Typography variant="miniText">Realização</Typography>
        <div className="flex items-center gap-2">
          <img
            src={logoSdec}
            className="py-3"
            alt="SDEC"
            style={{ height: "8vh" }}
          />
          <img src={logoAdepe} alt="ADEPE" style={{ height: "6vh" }} />
        </div>
      </div>
      <div>
        <Typography variant="miniText">Execução</Typography>
        <img src={senai} alt="Senai" style={{ height: "6vh" }} />
      </div>
    </div>
  );
}
